import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "Is InfraVest a security or fund?",
    a: "InfraVest is a platform. Any investment opportunities offered through it will be made only through compliant securities offerings and official offering documents. Early Access is a waitlist, not a solicitation.",
  },
  {
    q: "Who can participate?",
    a: "We expect to launch with offerings suitable for accredited investors first, with structures designed to broaden over time as regulation permits.",
  },
  {
    q: "What assets does InfraVest cover?",
    a: "Macro cell towers, dark and lit fiber routes, rooftop and small-cell sites, and edge data-center facilities — the physical layer of modern connectivity.",
  },
  {
    q: "I own a tower or fiber portfolio. What can I expect?",
    a: "A confidential conversation. We explore JV, partial monetization, or full acquisition pathways — designed so owners keep meaningful long-term participation.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-neutral-950 py-28 md:py-36"
    >
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.28em] text-orange-400">
              FAQ
            </p>
            <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl">
              Questions, answered<br />before you ask.
            </h2>
          </div>
        </div>

        <div className="mt-14 divide-y divide-white/10 border-y border-white/10">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors hover:bg-white/[0.02]"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-display text-lg font-medium text-white sm:text-xl">
                    {item.q}
                  </span>
                  <span
                    className={`grid h-9 w-9 flex-none place-items-center rounded-full border border-white/15 text-white transition-transform duration-300 ${
                      isOpen ? "rotate-180 border-orange-500/40 text-orange-400" : ""
                    }`}
                  >
                    <ChevronDown className="h-4 w-4" />
                  </span>
                </button>
                <div
                  className={`grid overflow-hidden transition-[grid-template-rows] duration-500 ${
                    isOpen ? "grid-rows-[1fr] pb-6" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="min-h-0 overflow-hidden">
                    <p className="max-w-2xl text-sm leading-relaxed text-neutral-400">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
